import { faceSlapRows } from "@/mocks/homeData";
import { SectionHead, Shell } from "./ui";

export default function FaceSlapSection() {
  return (
    <section className="bg-background-50">
      <Shell>
        <div className="py-10 md:py-14">
          <SectionHead
            id="slap"
            kicker="Face Slap · 说过的算数吗"
            title="打脸实录"
            subtitle="「绝无此事」到「主动改口」，把公开声明与事后实情并排对照，谁在嘴硬、谁已被打脸一目了然。"
            linkText="更多打脸现场"
          />

          <div className="flex flex-col gap-3">
            {faceSlapRows.map((r) => (
              <article
                key={r.id}
                className="grid grid-cols-1 gap-3 rounded-xl border border-background-200 bg-background-100/50 p-4 transition hover:border-accent-300 md:grid-cols-[160px_1fr_1fr_auto] md:items-center"
              >
                <div>
                  <span className="block text-sm font-bold text-foreground-950">{r.subject}</span>
                  <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                    <i className="ri-empathize-line" />
                    {r.result}
                  </span>
                </div>
                <div className="rounded-lg bg-background-50 px-3 py-2.5">
                  <span className="mb-0.5 block text-[10px] font-semibold uppercase tracking-wide text-background-500">曾放话</span>
                  <p className="text-sm text-foreground-600">{r.before}</p>
                </div>
                <div className="rounded-lg border-l-2 border-accent-500 bg-accent-100/40 px-3 py-2.5">
                  <span className="mb-0.5 block text-[10px] font-semibold uppercase tracking-wide text-accent-700">实情对照</span>
                  <p className="text-sm text-foreground-700">{r.after}</p>
                </div>
                <div className="flex items-center gap-2 md:flex-col md:items-end md:justify-center">
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-700 md:flex-row-reverse"><i className="ri-fire-line" />{r.heat}</span>
                  <button aria-label="展开" className="hidden h-8 w-8 place-items-center rounded-full border border-background-300 text-foreground-500 transition hover:border-primary-400 hover:text-primary-600 md:grid">
                    <i className="ri-arrow-right-s-line" />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Shell>
    </section>
  );
}